export default __webpack_public_path__ + "static/media/logo-pm.e4bf5fe1.png";